/**
 * Shared clinical vitals field keys + helpers.
 * Canonical shape matches Nurse Evaluation (Clinical Vitals & Trends).
 */

export { PAIN_LEVELS } from "../shared/PainIntensityScale";

export const CLINICAL_VITALS_FIELDS = [
  { key: "vitalsBp", label: "BP (mmHg)", placeholder: "120/80" },
  { key: "vitalsHr", label: "HR (bpm)", placeholder: "72" },
  { key: "vitalsRr", label: "RR (bpm)", placeholder: "16" },
  { key: "vitalsTemp", label: "Temp (°F)", placeholder: "98.6" },
  { key: "vitalsSpo2", label: "SpO2 (%)", placeholder: "98" },
  { key: "vitalsWeight", label: "Weight (lbs)", placeholder: "180" },
];

export const emptyClinicalVitals = () => ({
  vitalsBp: "",
  vitalsHr: "",
  vitalsRr: "",
  vitalsTemp: "",
  vitalsSpo2: "",
  vitalsWeight: "",
  painLevel: null,
});

const combineBp = (sys, dia) => {
  const s = String(sys || "").trim();
  const d = String(dia || "").trim();
  if (s && d) return `${s}/${d}`;
  return s || d || "";
};

const parsePainLevel = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  const rounded = Math.round(n);
  if (rounded < 0 || rounded > 10) return null;
  return rounded;
};

/**
 * Normalize any legacy vitals shape (Visit SYS/DIA + vitalsPain, etc.)
 * into the Evaluation canonical keys.
 */
export const normalizeClinicalVitals = (raw = {}) => {
  const src = raw && typeof raw === "object" ? raw : {};
  const vitalsBp =
    src.vitalsBp ||
    combineBp(src.vitalsBpSys, src.vitalsBpDia) ||
    "";
  const painLevel =
    parsePainLevel(src.painLevel) ??
    parsePainLevel(src.vitalsPain) ??
    null;

  return {
    vitalsBp,
    vitalsHr: src.vitalsHr || "",
    vitalsRr: src.vitalsRr || "",
    vitalsTemp: src.vitalsTemp || "",
    vitalsSpo2: src.vitalsSpo2 || "",
    vitalsWeight: src.vitalsWeight || "",
    painLevel,
  };
};

/** Strip legacy keys when saving so payloads stay on one schema. */
export const withCanonicalClinicalVitals = (payload) => {
  const next = { ...(payload || {}) };
  const vitals = normalizeClinicalVitals(next);
  Object.assign(next, vitals);
  delete next.vitalsBpSys;
  delete next.vitalsBpDia;
  delete next.vitalsPain;
  return next;
};
